import { Neo } from "@singularsystems/neo-react";
import React from 'react';
import { AppService, Types } from "../../DomainTypes";
import BankDetail from "../../Models/ValueObjects/BankDetail";
import { Catalogue } from '@singularsystems/neo-react-services';
import BankCatalogueEntry from "../Catalogue/GenericComponents/BankCatalogueEntry";
import BankAccountTypeCatalogueEntry from "../Catalogue/Pipelines/BankAccountTypeCatalogueEntry";

interface IBankDetailsProps {
    bankDetail: BankDetail;
}

export default class BankDetails extends React.Component<IBankDetailsProps> {

    public render() {
        const bankDetails = this.props.bankDetail;
        let cache = AppService.get(Types.Domain.Services.DataCache)

        return (
            <div>
                <Catalogue.FormGroupInline bind={bankDetails!.meta.bankId} catalogueType={BankCatalogueEntry} />
                <Neo.FormGroupInline bind={bankDetails!.meta.bankAccountName} />
                <Neo.FormGroupInline bind={bankDetails!.meta.bankBranchName} />
                <Neo.FormGroupInline bind={bankDetails!.meta.bankBranchCode} />
                <Neo.FormGroupInline bind={bankDetails!.meta.bankAccountNumber} />
                <Catalogue.FormGroupInline bind={bankDetails!.meta.bankAccountTypeId} catalogueType={BankAccountTypeCatalogueEntry} />
            </div>
        )
    }
}